"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../../../typography");
var Button_1 = __importDefault(require("../../../../basics/Button"));
var Grid_1 = __importDefault(require("../../../../basics/Grid"));
var VerticalSpacer_1 = __importDefault(require("../../../../utils/VerticalSpacer"));
var HorizontalSpacer_1 = __importDefault(require("../../../../utils/HorizontalSpacer"));
var Pill_1 = __importDefault(require("../../../../misc/Pill"));
var styles_1 = require("../../../../basics/Button/styles");
var Avatar_1 = __importDefault(require("../../../../misc/Avatar"));
var Link_1 = __importDefault(require("../../../Link"));
var styles_2 = require("./styles");
var VS_1 = { small: 8, medium: 16, large: 32 };
var HS_2 = { small: 4, medium: 6, large: 8 };
var AVATAR_SIZE = {
    small: styles_1.LEVEL_CONFIG['2'].small.height,
    medium: styles_1.LEVEL_CONFIG['2'].medium.height,
    large: styles_1.LEVEL_CONFIG['2'].large.height,
};
var Menu = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, user = _a.user, logInButton = _a.logInButton, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c;
    return (react_1.default.createElement(styles_2.Wrapper, { "$isOpen": isOpen },
        react_1.default.createElement(Grid_1.default, null,
            react_1.default.createElement(Grid_1.default.Cell, { span: "full" },
                react_1.default.createElement(styles_2.Content, null,
                    react_1.default.createElement("div", null, user ? (react_1.default.createElement(HorizontalSpacer_1.default, { amount: { small: 16, medium: 16, large: 16 } },
                        react_1.default.createElement(Avatar_1.default, { image: user.image, size: AVATAR_SIZE }),
                        react_1.default.createElement(VerticalSpacer_1.default, { amount: { small: 0, medium: 0, large: 0 } },
                            react_1.default.createElement(typography_1.Body, { level: "3" },
                                react_1.default.createElement("span", null, "Hello"),
                                react_1.default.createElement("span", null, user.name ? ", ".concat(user.name, "!") : '')),
                            react_1.default.createElement(typography_1.Body, { level: "3", color: "GREY_70" }, user.email)))) : (react_1.default.createElement(Button_1.default, { fullWidth: true, href: logInButton.href, isExternal: logInButton.isExternal, onClick: logInButton.onClick, version: logInButton.version }, logInButton.text))),
                    items.map(function (item, i) {
                        var _a, _b;
                        return (react_1.default.createElement("div", { key: i },
                            react_1.default.createElement(VerticalSpacer_1.default, { amount: VS_1 },
                                item.label && react_1.default.createElement(typography_1.Label, { color: "GREY_70" }, item.label),
                                react_1.default.createElement(react_1.default.Fragment, null, (((_a = item.items) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0
                                    ? (_b = item.items) === null || _b === void 0 ? void 0 : _b.map(function (subItem, subItemI) {
                                        var content = (react_1.default.createElement(HorizontalSpacer_1.default, { key: subItemI, amount: HS_2 },
                                            react_1.default.createElement(typography_1.Body, { level: "3", inline: true }, subItem.display),
                                            subItem.isNew && react_1.default.createElement(Pill_1.default, null, "New!")));
                                        if (subItem.href) {
                                            return (react_1.default.createElement(Link_1.default, { key: subItemI, href: subItem.href, isExternal: subItem.isExternal, color: "GREY_90", hoverColor: "BLUE_50", block: true }, content));
                                        }
                                        return content;
                                    })
                                    : item.children))));
                    }))))));
};
exports.default = Menu;
